import dayjs from "dayjs";
import utc from "dayjs-plugin-utc";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import useDocumentTitle from "../../utils/useDocumentTitle";

import styles from "./Teams.module.scss";

import { Metric, MetricsWrapper } from "../../components/Metric";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { DashboardLayout } from "../../layouts/DashboardLayout";

import CampaignFilter from "../../components/CampaignFilter";
import GetAllCountries from "../../components/GetAllCountries";
import SupportAdminTable from "./SupportAdminTable";

dayjs.extend(utc);

export function TeamSupportAdmin(props) {
  useDocumentTitle(props.title);
  const history = useHistory();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  //ascending
  //descending

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle>Teams</SectionTitle>

            <div className={styles.toolBar}>
              <GetAllCountries
                countryChange={val => {
                  setSelectedCountry(val);
                }}
              />
              <CampaignFilter
                handleCampaignChange={val => {
                  setSelectedCampaign(val);
                }}
              />
            </div>

            {selectedCampaign && (
              <MetricsWrapper>
                <Metric
                  label="Coach"
                  api="getSupportAdminTotalNumberOfCoachCoachee"
                  responseKey="response.data.data.coach"
                  isCampaign={selectedCampaign}
                  customParams={`country_id=${selectedCountry}&campaign_id=${selectedCampaign}`}
                />
                <Metric
                  label="Coachees"
                  api="getSupportAdminTotalNumberOfCoachCoachee"
                  responseKey="response.data.data.coachee"
                  isCampaign={selectedCampaign}
                  customParams={`country_id=${selectedCountry}&campaign_id=${selectedCampaign}`}
                />
              </MetricsWrapper>
            )}

            <SupportAdminTable
              selectedCountry={selectedCountry}
              selectedCampaign={selectedCampaign}
            />
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
